export default {
	voteAction: '投票',
	videoNavLabel: '视频',
	vipLevelLabel: 'VIP等级',
	betOptions: { rose: '玫瑰', lily: '百合', fireworks: '烟花', balloon: '气球' },
	Language: '中文',
	registerPasswordLength: '密码长度必须为6至12位',
	system: {
		homePage: {
			title1: '标题1',
			title2: '标题2',
			description1: '近7日',
			description2: '近6个月',
		}
	},
	login:{
		subtitle:'开启今晚的专属邂逅',
		register:'注册会员',
		usernamePls:'请输入用户名',
		passwordPls:'请输入密码',
		toRegister:'没有账号吗？现在注册会员吧',
		doLogin:'登录',	  
	},
	googleAuth:{
		or:'或',
		processing:'正在验证 Google 账号…',
		configMissing:'Google 登录尚未配置，请联系管理员',
		unavailable:'Google 登录暂时不可用，请稍后重试',
		failed:'Google 登录失败，请稍后重试',
		invalidResponse:'登录服务未返回有效凭证',
		success:'Google 登录成功',
		inviteTitle:'填写邀请码',
		inviteDescription:'这是该 Google 账号首次进入，请填写有效邀请码完成开户。以后使用同一 Google 账号可直接进入。',
		cancel:'取消',
		continue:'继续进入'
	},
	register:{
		repasswordPls:'请输入取款密码',  
		codePls:'请输入邀请代码',  
		register:'注册',
		xieyi:'同意使用条款',
		xieyiPls:'请选择下面的开户协议！',
	},
	mine:{
		xyfs:'信用分数',
		ljjf:'累计积分',
		recharge:'充值',
		withdraw:'提现',
		money:'可用余额',
		infomation:'基本信息',
		moneylog:'积分记录',
		withdrawrecord:'提款明细',
		gamerecord:'礼品记录',
		notice:'公告事项',
		mymove:'观看记录',
		loginpwd:'登录密码',
		paypwd:'使用密码',
		loginout:'注销',
		paypwdhasseted:'已设置取款密码。如果需要修改，请与客户中心联系',
		setbank:'请设置收款卡！',
		lorr:'登录/注册',
	},
	infomation:{
		username:'会员ID',
		name:'姓名',
		bankcard:'提款账户',
		phone:'手机号码',
		recharge:'充值',
		amount:'拥有点',
		toserve:'请联系客户服务',
		kfms:'想要线下充电，请向客服咨询。部分结算渠道的充值金额将随机充值至小数点1位，结算时请务必确认',
	},
	withdraw:{
		title:'提现',
		log:'取款记录',
		method:'取款方法',
		avmoney:'可提现余额',
		limit:'取款限度',
		submit:'提款申请',
		xiane:'单笔限额',
		numbers:'取款次数',
		time:'到账时间',
		zuidi:'最少',
		zuigao:'最高',
		numsmax:'每天最多提取现金',
		ci:'次',
		timedetail:'一般汇款时间为5分钟左右，最快在2分钟内汇款',
		bank:'银行卡',
		status1:'待审核',
		status2:'成功',
		status3:'失败',
		enterCorrectAmount: '请填写正确的金额',
		selectBankCard: '请选择提现银行卡',
		enterPayPassword: '请输入支付密码',
	},
	moneylog:{
		title:'资金明细',
		summary:'累计汇总',
		summaryRecharge:'充值总额',
		summaryTask:'任务总额',
		summaryIncome:'收益总额',
		summaryWithdraw:'提现总额',
		type1:'变更',
		type2:'彩金',
		type3:'任务',
		type4:'奖金',
		type5:'取款',
		type6:'取款失败',
		rechargeNote: '（充值）',
	},
	setting:{
		loginpwdtitle:'更改登录密码',
		oldpwd:'请输入旧密码',
		newpwd:'请输入新密码',
		renewpwd:'请重新输入新密码',
		change:'更改',
		plseall:'请填写完整表格！',
		pswwrong:'两次密码输入不匹配',
		paypwdtitle:'设置资金密码',
		paypwd:'请输入资金密码',
		repaypwd:'请重新输入资金密码',
		title: '设置',
		basicInfo: '基本信息设置',
		loginPassword: '登录密码',
		fundPassword: '资金密码',
		logout: '退出登录',
		payPasswordSet: '提现密码已设置，需要修改请联系客服',
		payPasswordNotSet: '未设置',
		payPasswordHasSet: '已设置',
		confirm: '确认',
	},
	home:{
		gonggao:'享受终极奢华体验',
		qgkf:'全国可能',
		hotlist:'人气推荐列表',
		hotgame:'任务推荐',
		gaoji:'高级',
		smrz:'实地认证',
		videorz:'本人视频认证',
		star:'评分',
		sg:'身高',
		xw:'胸围',
		diqu:'可服务区域',
		apply:'申请约会',
		ssxz:'实时现状',
		joinvip:'加入了会员',
	},
	video:{
		latest:'最新',
		title:'影像馆',
		nums:'播放量',
		bofangliang:'播放量',
		hotlist:'人气推荐',
		plsrefisrt:'请充值后看视频！',
		// ... 其他视频相关翻译
	    trialEnded: '试看结束',
	    rechargeToWatch: '请充值后免费观看',
		goRecharge: '立即充值',
	},
	choose:{
		title:'最好的一夜',
		nav:'选妃',
		apply:'匹配申请',
		jianjie:'美女简介',
		move:'是否可移动',
		click:'点击认证',
		giftPoints:'赠送花点',
		giftTitle:'赠送花点',
		giftBalance:'可用点数：',
		giftAmount:'花点数量',
		giftCustomPlaceholder:'请输入花点数量',
		giftConfirm:'确认赠送',
		giftSending:'赠送中...',
		giftSuccess:'花点赠送成功',
		giftInvalid:'请输入 1 到 1000000 的整数',
		giftInsufficient:'可用点数不足',
		detail:'详细信息',
		videodetail:'实时视频',
	},
	common:{
		refresh:'刷新成功',
		noallow:'功能已禁用！',
		disable:'禁用',
		all:'全部',
		nomore:'没有更多了',
		nodata:'无数据',
		submit:'提交',
		more:'查看更多',
		pinglunnav:'评论',
		pingluntitle:'评论',
		pldtitle:'评论详情',
		minenav:'账户',
		homenav:'主页',
		addbank:'添加收款卡',
		setbank:'提款账户',
	},
	game:{
		expect:'期号',
		jieguo:'数据',
		da:'大',
		xiao:'小',
		dan:'单',
		shuang:'双',
		大:'大',
		小:'小',
		单:'单',
		双:'双',
		order:'任务单',
		clear:'清空订单',
		submit:'确认提交',
		rewardSuccess:'打赏成功',
		kjcc:'开奖成功，期号:',
		lxgly:'请与您的管理员联系',
		plsmoney:'请填写金额!',
		plsnum:'请选择号码!',
		moneynote:'余额不足，请联系客服充值!',
		lefttime:'剩余时间',
		lunci:'期号',
		workRecord: '任务记录',
		day: '日',
		period: '期',
		allWork: '所有任务',
		reset: '重置',
		confirm: '确认',
		bonusPoints: '奖励积分',
		missionMoney: '任务金额明细',
		missionResult: '任务结果',
		points: '积分',
		workPoints: '任务积分',
		giftCompleted: '礼品已完成',
		orderTime: '订单时间:',
		detail: '详情',
		content: '内容',
		amount: '金额',
		result: '结果',
		time: '时间',
		win: '获胜',
		missionFailed: '任务失败',
	},
	kefu:{
		title:'在线客服',
		lianxi:'联系',
		content:'全天7 * 24小时竭诚为您服务',
		defaultName: '在线客服',
	},
	setname:{
		title:'修改实名',
		xingming:'名字',
		tips:'为了您的账户安全，实际名称必须与绑定银行卡名称匹配',
		xmpls:'请输入实际名称',
		save:'保存',
		notreset:'不要重复设置！',
		plsentername:'请输入名称！',
	},
	// 新增的语言键
	withdrawCenter: '提现中心',
	withdrawRecord: '提现记录',
	withdrawAmount: '提现金额',
	allMoney: '全部',
	singleLimit: '单笔限额',
	lowest: '最低',
	highest: '最高',
	withdrawTimes: '提现次数',
	maxDailyWithdraw: '一天最高提现',
	times: '次',
	arrivalTime: '到账时间',
	limitDescription: '限额说明',
	balance: '余额',
	withdrawNow: '马上提现',
	enterCorrectAmount: '请填写正确的金额',
	personalReport: '个人报表',
	profitAmount: '盈利金额',
	profitFormula: '盈利计算公式 : 中奖金额 - 任务金额',
	taskAmount: '任务金额',
	accountOffline: '账号下线',
	loginRegister: '登录/注册',
	loginForMore: '登录可享受更多服务！',
	// 评论相关
	author: '作者:',
	notification: '通知',
	// 设置相关
	changePhone: '修改手机号',
	save: '保存',
	existingPhone: '现有手机号',
	newPhone: '新手机号',
	// 银行相关
	withdrawAccountRegister: '提款账户注册',
	selectBankCard: '请选择银行卡',
	accountNumber: '账户号码',
	enterBankCardNumber: '请输入银行卡号码',
	// 通知相关
	systemNotice: '系统通知',
	// 观看记录相关
	myMovie: '我的电影',
	completeTaskForMore: '完成任务以获得更多电影票',
	movieTicket: '电影票:',
	watchList: '观看列表',
	noDataYet: '暂无数据',
	// 其他
	setNameFirst: '请先设置姓名后再关联提款账户！',
	setPasswordFirst: '请先设置提现密码后再绑定银行卡！',
	// 银行相关
	accountHolder: '账户持有人',
	enterRealName: '请输入真实姓名',
	withdrawPassword: '提款密码',
	registerWithdrawPassword: '请注册提款密码',
	bankCard: '银行卡',
	// 游戏相关
	orderContentLabel: '订单内容:',
	all: '全部',
	bonusPointsLabel: '奖励积分',
	waitingResultLabel: '等待结果',
	missionMoneyDetails: '任务金额明细',
	points: '积分',
	// 彩票相关
	switch: '开关',
	currentSelection: '当前选择:',
	quantity: '数量:',
	total: '总计',
	ticketAmount: '票数',
	availablePoints: '可用积分',
	verify: '验证',
	// 个人资料相关
	possible: '可能',
	thumb: '拇指',
	privacyPolicy: '隐私政策',
	romanticDescription: '我们的浪漫服务为了保护会员的个人信息，通过实名认证服务完成认证或通过已完成认证的会员推荐才能注册。',
	// 首页相关
	person1: '夏雨',
	person2: '敏雪',
	lishijl: '历史记录',
	cryptoWithdraw: { title:'加密货币提现',record:'提现记录',assetTitle:'数字资产提现',assetSubtitle:'安全转入您的加密货币钱包',selectCoin:'选择币种',selectNetwork:'选择网络',walletAddress:'接收钱包地址',walletPlaceholder:'请输入钱包地址',addressTip:'请确认地址支持 {network} 网络，链上转账无法撤回。',amount:'提现金额',all:'全部',availableBalance:'可用余额',network:'提现网络',fee:'预计手续费',arrival:'预计到账',confirm:'确认提现',submitting:'提交中...',safetyInfo:'提现安全说明',safetyCaption:'支付密码与加密验证共同保护您的资金安全',verification:'安全验证',passwordPrompt:'请输入支付密码以确认本次提现',payPassword:'支付密码',passwordPlaceholder:'请输入支付密码',cancel:'取消',rulesTitle:'加密货币提现说明',rule1:'请确保钱包地址支持所选币种和网络。',rule2:'提现申请提交后将进行安全审核。',rule3:'实际到账时间取决于区块链网络状态。',rule4:'链上交易完成后无法撤销，请仔细核对地址。',enterAddress:'请输入接收钱包地址',invalidAddress:'钱包地址格式与所选网络不匹配',invalidAmount:'提现金额必须大于网络手续费',insufficientBalance:'提现金额不能超过可用余额',enterPassword:'请输入支付密码',passwordError:'支付密码错误',success:'提现申请已提交',failed:'提现失败，请稍后重试' },
	cryptoAddress:{bind:'提前绑定地址',title:'绑定提现地址',selectCoin:'选择币种',selectNetwork:'选择网络',address:'钱包地址',placeholder:'请输入钱包地址',tip:'请确认地址支持当前币种和网络，保存后将用于提现。',save:'保存地址',modify:'修改地址',saving:'保存中...',invalid:'钱包地址格式不正确',success:'地址保存成功',scanSuccess:'二维码识别成功',scanFail:'未识别到有效的钱包二维码',verify:'验证交易密码',password:'交易密码',passwordPlaceholder:'请输入交易密码',confirm:'确认修改',cancel:'取消',passwordRequired:'请输入交易密码'},
};

